var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{on:{"mouseover":function($event){_vm.hovered=true},"mouseout":function($event){_vm.hovered=false},"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.sort !== false)?_c('open-icon',{class:{ 'active': !!_vm.sort || _vm.hovered, 'text-gray': !_vm.sort && !_vm.hovered, 'ml-4': !_vm.compact },attrs:{"glyph":_vm.glyph}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }